import classNames from 'classnames';
import { IMapSlotClose } from 'common/tile/tile-body-header-v2-element.js';
import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { LinkRef } from 'components-modules/condition/link-ref.js';
import { ReactNode } from 'react';
import { IModule } from 'redux-state/layout/types.js';

export const GenericMarkerDescription = <T,>({
  config,
  children,
  modulePath,
  dataModule,
}: IModule<T & IMapSlotClose> & { children: ReactNode; dataModule: string }) => {
  const { subtitle, link } = config;

  return (
    <Tile dataModule="marker-description-gen" config={config}>
      <div className={classNames('Tile-body')} data-module={dataModule}>
        <TileBodyHeaderV2
          modulePath={modulePath}
          config={{ ...config, ...{ subtitle, title: config.title } }}
          onModuleClose={config.onModuleClose}
        />
        {children}
        <LinkRef link={link ?? config.link} />
      </div>
    </Tile>
  );
};
